<script lang="ts">
    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'
    import { sanchor, spath } from 'hydria/svelte_helpers'

    import type { AdminUser, AuthLog, AutoToken } from './TwofaDefs'

    interface Props {
        entry: AuthLog
        autoTokens?: { [key: string]: AutoToken }
        adminUsers?: { [key: string]: AdminUser }
    }

    let { entry, autoTokens = {}, adminUsers = {} }: Props = $props()
</script>

{#if entry.reference_type == 'password'}
    <Icon inline icon="mdi:password" /> {$_('Mot de passe')}
{:else if entry.reference_type == 'admin'}
    <Icon inline icon="mdi:administrator" /> Site administratif :
    {#if adminUsers[entry.reference_id] != null}
        <a use:sanchor href={spath(`/admin-user/${entry.reference_id}`)}>{adminUsers[entry.reference_id].email}</a>
    {:else}
        (?? Deleted?)
    {/if}
{:else if entry.reference_type == 'auto-signin-token'}
    <Icon inline icon="mdi:administrator" /> Connecté admin
    {#if autoTokens[entry.reference_id] && adminUsers[autoTokens[entry.reference_id].admin_user_id]}
        <a use:sanchor href={spath(`/admin-user/${autoTokens[entry.reference_id].admin_user_id}`)}>{adminUsers[autoTokens[entry.reference_id].admin_user_id].email}</a>
    {:else}
        (??)
    {/if}
{:else if entry.reference_type == 'request-token'}
    <Icon inline icon="mdi:email-lock" /> {$_('Récupération par courriel')}
{:else if entry.reference_type == 'totp'}
    <Icon inline icon="mdi:cellphone" /> {$_('Application')}
{:else if entry.reference_type == 'sms'}
    <Icon inline icon="mdi:message-text" />
    {$_('Code par SMS')}
    {#if entry.e_name}{$_(' (« {name} »)', { name: entry.e_name })}{/if}
{:else if entry.reference_type == 'email'}
    <Icon inline icon="mdi:email" />
    {$_('Code par courriel')}
    {#if entry.e_name}{$_(' (« {name} »)', { name: entry.e_name })}{/if}
{:else if entry.reference_type == 'passkey'}
    <Icon inline icon="mdi:shield-key" />
    {$_('Clé d’accès')}
    {#if entry.p_name}{$_(' (« {name} »)', { name: entry.p_name })}{/if}
{:else if entry.reference_type == null}
    <Icon inline icon="mdi:question-mark" /> <span class="text-muted">non-inscrit</span>
{:else}
    <Icon inline icon="mdi:question-mark" /> ??? ({entry.reference_type})
{/if}
